import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Grid, Button, Typography, Link } from '@hbf/dsl';
import { UserQuestion } from '@hbf/icons/custom';
import { useIntl } from 'ha/i18n';

const useStyles = makeStyles()(theme => ({
  title: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },

  cta: {
    marginTop: theme.spacing(2),
  },
}));

export const CheckFAQs: React.FC = () => {
  const { classes } = useStyles();
  const { T } = useIntl();

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid item>
        <UserQuestion fontSize="large" style={{ fill: 'none' }} />
      </Grid>
      <Grid item alignItems="center">
        <Typography.ParagraphTitle align="center" className={classes.title}>
          {T('contact.faq_title')}
        </Typography.ParagraphTitle>
      </Grid>

      <Grid item alignItems="center">
        <Typography.Paragraph align="center">
          {T('contact.faq_intro')}
        </Typography.Paragraph>
      </Grid>

      <Grid
        container
        spacing={1}
        direction="row"
        alignItems="center"
        justifyContent="space-evenly"
        className={classes.cta}
      >
        <Link
          target="_blank"
          to="https://answers.housinganywhere.com/en/collections/1445947-tenants"
        >
          <Button
            color="primary"
            type="submit"
            variant="outlined"
            data-test-locator="For Tenants Button"
          >
            {T('cta.for_tenants')}
          </Button>
        </Link>

        <Link
          target="_blank"
          to="https://answers.housinganywhere.com/en/collections/1445961-advertisers"
        >
          <Button
            color="primary"
            type="submit"
            variant="outlined"
            data-test-locator="For advertisers Button"
          >
            {T('cta.for_advertisers')}
          </Button>
        </Link>
      </Grid>
    </Grid>
  );
};
